// Google Analytics utility functions

declare global {
    interface Window {
        gtag?: (command: string, targetId: string, config?: Record<string, unknown>) => void;
    }
}

export const GA_TRACKING_ID = 'G-LPHL063X2X'; // Replace with actual tracking ID

// Track page views
export const pageview = (url: string, title: string) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: url,
            page_title: title,
        });
    }
};

// Track custom events
export const event = (action: string, category: string, label?: string, value?: number) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

// Track blog post views
export const trackBlogPostView = (slug: string, title: string) => {
    event('view_blog_post', 'Blog', `${slug} - ${title}`);
};

// Track tag clicks
export const trackTagClick = (tag: string, fromPage: string) => {
    event('click_tag', 'Navigation', `${tag} (from ${fromPage})`);
};
